import React, { useEffect, useState } from "react";
import { Badge, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getTourAvailability } from "../../Api/TourApi";

function badgeFor(seats) {
  if (seats > 7) return { variant: "success", label: "Available" };
  if (seats > 3) return { variant: "warning", label: seats + " left" };
  if (seats > 0) return { variant: "danger", label: seats + " left" };
  return { variant: "secondary", label: "Sold Out" };
}

/** The short "next dates" list used on tour cards and the tour page booking panel. */
const AvailabilitySmall = ({ thundertixId, slug }) => {
  const [status, setStatus] = useState("loading");
  const [dates, setDates] = useState([]);

  useEffect(() => {
    let cancelled = false;
    if (!thundertixId) {
      setStatus("empty");
      setDates([]);
      return undefined;
    }
    setStatus("loading");
    setDates([]);
    getTourAvailability(thundertixId)
      .then((list) => {
        if (cancelled) return;
        setDates(list);
        setStatus(list.length ? "ready" : "empty");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [thundertixId]);

  return (
    <div className="avail" aria-live="polite">
      {status === "loading" && (
        <div className="avail__status">
          <Spinner animation="border" size="sm" role="status">
            <span className="sr-only">Loading upcoming dates…</span>
          </Spinner>
        </div>
      )}
      {status === "empty" && <div className="avail__status">Check back soon for new dates</div>}
      {status === "error" && (
        <div className="avail__status">
          Dates are unavailable right now. Call <a href="tel:+18599518560">(859) 951-8560</a>.
        </div>
      )}
      {status === "ready" && (
        <ul className="avail__list">
          {dates.map((d) => {
            const badge = badgeFor(d.availability);
            const when = (
              <span className="avail__when">
                <span className="avail__date avail__date--long">{d.month} {d.day}</span>
                <span className="avail__date avail__date--short">{d.short}</span>
                {" – "}
                {d.time}&nbsp;{d.ampm}
              </span>
            );
            const pill = (
              <Badge variant={badge.variant} className="avail__badge">
                {badge.label}
              </Badge>
            );
            return (
              <li key={d.performanceId}>
                {d.availability > 0 ? (
                  <Link
                    to={`/${slug}/checkout/${d.performanceId}`}
                    className="avail__row"
                    aria-label={`Book ${d.dayofweek} ${d.month} ${d.day} at ${d.time} ${d.ampm}, ${badge.label}`}
                  >
                    {when}
                    {pill}
                  </Link>
                ) : (
                  <div className="avail__row avail__row--soldout" aria-disabled="true">
                    {when}
                    {pill}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default AvailabilitySmall;
